module.exports = __webpack_public_path__ + "static/media/Pragmatic.930ec600.png";